import React, { FC } from "react";

import { TModalComponentsItemProps } from "../../types/ContentHubSeriesDetails.type";
import CTAWithArrow from "../../../../react-only-components/CTAWithArrow";
import RoutableNotEditableLink from "../../../../react-only-components/RoutableNotEditableLink";
import { BreakpointsInPx } from "../../../../constants/breakpoints.constants";

const InnerCard: FC<TModalComponentsItemProps> = (props) => {
  const model = props.component;
  const asset = model?.assets?.length ? model.assets[0] : null;

  return (
    <section className="inner-cards-module">
      {asset && (
        <picture className="inner-cards-module__picture--fixed-aspect-ratio">
          <source
            srcSet={asset.bigthumbnail}
            media={`(min-width: ${BreakpointsInPx.md})`}
          />
          <source
            srcSet={asset?.thumbnail}
            media={`(min-width: ${BreakpointsInPx.xs})`}
          />
          <img loading="lazy" src={asset?.bigthumbnail} alt={asset.alt} />
        </picture>
      )}
      {model?.title && (
        <h2 className="inner-cards-module__title">{model?.title}</h2>
      )}
      {model?.description && (
        <div
          className="inner-cards-module__description"
          dangerouslySetInnerHTML={{ __html: model?.description }}
        ></div>
      )}
      <div className="inner-cards-module__ctas">
        {(model?.button1?.url || model?.button1?.label) && (
          <pfe-cta
            pfe-priority="primary"
            class="inner-cards-module__primary-link"
          >
            <RoutableNotEditableLink href={model?.button1?.url}>
              {model?.button1?.label}
            </RoutableNotEditableLink>
          </pfe-cta>
        )}
        {(model?.button2?.url || model?.button2?.label) && (
          <CTAWithArrow
            href={model?.button2?.url}
            text={model?.button2?.label}
          />
        )}
      </div>
    </section>
  );
};

export default InnerCard;
